/**
  * 判断是否为Null
  *
  * @param {Object} obj 对象
  * @return {Boolean}
  */
function isNull (obj) {
  return obj === null
}

module.exports = isNull



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/base/isNull.js
// module id = 59
// module chunks = 106